import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import Holidays from 'date-holidays';

const getHolidayDates = () => {
  const hd = new Holidays('AU', 'NSW');
  const publicHolidays = hd.getHolidays(new Date().getFullYear()).map(h => h.date.split(' ')[0]);

  const closedDates = [];
  let closureDate = new Date('12/20/2025');
  const closureEnd = new Date('01/25/2026');
  while (closureDate <= closureEnd) {
    closedDates.push(closureDate.toISOString().split('T')[0]);
    closureDate.setDate(closureDate.getDate() + 1);
  }

  return [...publicHolidays, ...closedDates];
};

// Tenant inspection blockout dates only restrict inspection booking, not other
// date fields (e.g. document submissions) that also restrict holidays.
const getBlockoutDates = () => JSON.parse(document.body.dataset.blockoutDates || '[]');

export default function() {
  const dateInputs = document.querySelectorAll('input[type="date"]');
  if (!dateInputs.length) return;

  let holidayDates = null;

  dateInputs.forEach(input => {
    if (input._flatpickr) return;

    const isBooking = input.dataset.booking === 'true';
    const restrictHolidays = isBooking || input.dataset.restrictHolidays === 'true';
    // Staff booking inputs: block tenant blockout dates only (no holiday/weekend/lead-time rules)
    const restrictBlockout = input.dataset.restrictBlockout === 'true';

    const options = {
      dateFormat: 'Y-m-d',
      altInput: true,
      altFormat: 'd/m/Y',
      allowInput: true,
      appendTo: document.body,
      // Flatpickr defaults to the native OS date picker on mobile user agents,
      // which bypasses our holiday/blockout/lead-time restrictions entirely.
      disableMobile: true,
      // Flatpickr drops the preloaded value if it fails the disable/minDate check (e.g.
      // rescheduling an inspection currently booked for today, which is before the
      // minDate) — this keeps the existing date visible while still blocking new
      // selections of disabled/out-of-range dates.
      allowInvalidPreload: true,
    };

    if (restrictHolidays) {
      if (!holidayDates) holidayDates = getHolidayDates();
      options.disable = isBooking
        ? [...holidayDates, ...getBlockoutDates(), date => date.getDay() === 0 || date.getDay() === 6]
        : [...holidayDates];
    } else if (restrictBlockout) {
      options.disable = getBlockoutDates();
    }

    if (isBooking) {
      // Clients must book at least 2 days out; matches the lead time the
      // external booking flow always enforced (see rebindDatePicker on master).
      const minDate = new Date();
      minDate.setDate(minDate.getDate() + 2);
      minDate.setHours(0, 0, 0, 0);
      options.minDate = minDate;
    }

    flatpickr(input, options);
  });
}
